// Rubric level descriptions — Podcast Verbal Skills Assessment
// ---------------------------------------------------------------------------
// Shown as a hover tooltip next to each rating level button in the
// "Assess Students" tab (App.js). To change the wording, edit the text
// below and redeploy — no other code changes needed.
//
// Keys must match the `label` values in the RATINGS array in App.js exactly.
export const RUBRIC_LEVEL_DESCRIPTIONS = {
  "Getting Started":
    "May stammer or hesitate while trying to formulate thoughts into words. Doesn't yet project confidence.",
  "Building Skills":
    "Improving at weaving thoughts into a coherent storyline. Miscues happen less often, though they can still seem frustrating for the student when they occur.",
  "Demonstrating Proficiency":
    "Starting to find their voice, with real storytelling ability beginning to shine through. Very few miscues, and they find their footing again quickly when one does happen.",
  "Excelling":
    "Projecting real comfort in their voice and storytelling ability. Miscues rarely happen at all, and when something unexpected does occur, they pivot quickly without losing their footing. Professional sounding throughout.",
};
